import { extractSourceName, fetchVideo } from "./../utils/glance";
import React, { useEffect } from "react";
import YoutubeVideo from "./Video";
import NativeVideo from "./NativeVideo";
import css from "./story.module.scss";
import { fireEvent } from "../utils/tracking";

export default function Glance(props) {
  const glance = props.glance;
  const imgUrl = glance.image.url;
  const isNativeVideo = fetchVideo(glance);
  const style = {
    background:
      "linear-gradient(to bottom, rgba(0, 0, 0, 0.29), rgba(0, 0, 0, 0) 18%, rgba(0, 0, 0, 0) 53%, rgba(0, 0, 0, 0.76)),url(" +
      imgUrl +
      ")",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    height: props.styles.height
  };
  useEffect(() => {
    fireEvent("Glance Story", "Load", glance.id);
  }, [glance.id]);
  function populateCTAText() {
    if (
      glance &&
      (glance.type === "STORY" || glance.type === "SPONSORED") &&
      glance.peek
    ) {
      if (
        glance.peek.type === "ARTICLE" &&
        glance.peek.articlePeek.cta.text.trim()
      ) {
        return (
          <a
            className={css["cta-btn"]}
            href={glance.peek.articlePeek.cta.url}
            target="_blank"
            onClick={fireCTAEvent}
            rel="noopener noreferrer"
          >
            {glance.peek.articlePeek.cta.text}
          </a>
        );
      }
    }
  }

  function fireCTAEvent() {
    fireEvent("Glance", "CTA Click", glance.id);
  }

  function turnOnGlance() {
    fireEvent("Glance Story", "Click - Turn On Glance", glance.id);
  }

  return (
    <div className={css["glance-card"]} style={style}>
      <div className={css["app-header"]}>
        <div className={css["logo"]}>
          <img
            loading="lazy"
            src={"../../../static/images/glance-white.png"}
            alt="Glance logo"
          />
        </div>
      </div>
      {isNativeVideo ? (
        <NativeVideo image={imgUrl} glance={glance} index={props.index} />
      ) : (
        <YoutubeVideo glance={glance} index={props.index} />
      )}
      <div className={css["content-cont"]}>
        <div className={css["content"]}>
          <div className={css["turn-on-btn-cont"]}>
            <a
              href={`/redirect?utm_source=${props.query.utm_source}&utm_medium=${props.query.utm_medium}&utm_campaign=${props.query.utm_campaign}-${glance.id}`}
              onClick={turnOnGlance}
              className={css["turn-on-glance"]}
            >
              Turn On Glance
            </a>
          </div>
          <div className={css["social-icons"]}>
            <div className={css["btn-cont"]}>
              <span className={css["source-name"]}>
                Article by {extractSourceName(glance) || "Glance"}
              </span>
              <span className={css["copyright-image"]}>
                {glance.attribution.text}
              </span>
            </div>
            {populateCTAText(glance)}
          </div>
        </div>
      </div>
    </div>
  );
}
